import { Divider, Link, Stack, Typography } from '@mui/material';
import React from 'react';
import Background from 'v2/components/Background/Background';

const InvalidOTR: React.FC<React.PropsWithChildren> = () => (
  <Background id="background">
    <Stack margin="0 auto" width="300px" flexDirection="column" gap={1} padding="48px 80px">
      <Typography variant="h4" color="textPrimary">
        Link expired or already used
      </Typography>
      <Divider />
      <Stack flexDirection="column">
        <Typography variant="body1" color="textPrimary">
          The URL you have clicked is no longer valid. This may be due to the link expiring or being used already.
        </Typography>
        <Typography variant="body1" color="textPrimary">
          If you believe this is an error, please contact your reseller or{' '}
          <Link id="tkh-security-link" href="https://tkhsecurity.com/" target="_blank" rel="noopener noreferrer">
            TKH Security
          </Link>{' '}
          for assistance.
        </Typography>
      </Stack>
    </Stack>
  </Background>
);

export default InvalidOTR;
